import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const BookSectionTemplateIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M0.5 13V5.00391C0.500036 3.62131 1.62146 2.50006 3.00391 2.5H3.5C3.77609 2.5 3.99992 2.72393 4 3C4 3.27614 3.77614 3.5 3.5 3.5H3.00391C2.17362 3.50006 1.50004 4.17372 1.5 5.00391V13C1.50004 13.8284 2.17165 14.4999 3 14.5H11C11.8284 14.5 12.5 13.8284 12.5 13V12C12.5001 11.7239 12.7239 11.5 13 11.5C13.2761 11.5 13.4999 11.7239 13.5 12V13C13.5 14.3807 12.3807 15.5 11 15.5H3C1.61939 15.4999 0.500065 14.3806 0.5 13Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M13.7041 0.510742C14.7128 0.613005 15.5 1.46435 15.5 2.5V10.5L15.4961 10.5615C15.4968 10.5826 15.5 10.6037 15.5 10.625C15.5 11.6605 14.6605 12.5 13.625 12.5H5.375C4.33947 12.5 3.5 11.6605 3.5 10.625C3.5 10.6037 3.50223 10.5826 3.50293 10.5615L3.5 10.5V2.5C3.5 1.39543 4.39543 0.5 5.5 0.5H13.5L13.7041 0.510742ZM5.375 9.75C4.91146 9.75 4.53311 10.1105 4.50293 10.5664C4.53713 11.0877 4.97005 11.5 5.5 11.5H13.5C14.0299 11.5 14.4619 11.0877 14.4961 10.5664C14.4659 10.1105 14.0885 9.75 13.625 9.75H5.375ZM5.5 1.5C4.94772 1.5 4.5 1.94772 4.5 2.5V8.9668C4.76127 8.82865 5.05889 8.75 5.375 8.75H13.625C13.9411 8.75 14.2387 8.82865 14.5 8.9668V2.5C14.5 1.94772 14.0523 1.5 13.5 1.5H5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
